import _ from 'lodash';
/**
 * A class that can return the Permission model
 */
export class Permission {
  /** @param {Object} permission FastJson object. */
  constructor(permission = {}) {
    this.id = permission.id || null;
    this.sym = permission.attributes.permission_sym;
    this.globalPermissionId = permission.attributes.global_permission_id || null;
    this.globalHolders = permission.attributes.global_holders ?
      _.map(permission.attributes.global_holders, ((holder) => ({
        id: holder.id,
        userId: holder.user_id,
        name: `${holder.first_name} ${holder.last_name}`
      }))) :
      [];
    this.enabled = (permission.attributes.subject_users && permission.attributes.subject_users.length !== 0) ||
      this.globalPermissionId !== null;
    this.subjectUsers = permission.attributes.subject_users ?
      _.map(permission.attributes.subject_users, ((user) => ({id: user.id, name: `${user.first_name} ${user.last_name} `}))):
      [];
  }
}
